export enum SearchStrategyAction {
  CreateStrategy = 1,
  UpdateStrategy = 2,
  AddFilter = 3,
  UpdateFilter = 4,
}
